import React from 'react';
import { TextField } from '@mui/material';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface CurrencyInputProps {
  value: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
  size?: "small" | "medium";
  variant?: "standard" | "filled" | "outlined";
  label?: string;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  onChange,
  fullWidth = true,
  size = "small",
  variant = "outlined",
  label = "Valor"
}) => {
  const numberValue = value ? parseFloat(value) : undefined;

  const handleValueChange: NumericFormatProps['onValueChange'] = (values) => {
    onChange(values.floatValue !== undefined ? values.floatValue.toString() : '');
  };

  return (
    <NumericFormat
      value={numberValue}
      onValueChange={handleValueChange}
      decimalScale={2}
      fixedDecimalScale
      thousandSeparator="."
      decimalSeparator=","
      prefix="R$ "
      customInput={TextField}
      fullWidth={fullWidth}
      size={size}
      variant={variant}
      label={label}
    />
  );
};

export default CurrencyInput;
